'use client';

import { useEffect, useRef } from 'react';
import { Cobe } from '@/components/cobe/Cobe';
import { DMImage } from '@/components/custom-image/custom-image';
import { useToast } from '@/components/ui/use-toast';
import useDialog from '@/hooks/useDialog';
import { useSession } from 'next-auth/react';
import rewardLottie from '../../../public/lottie/Reward-Lottie3.json';
import { HomeLayout } from './layout';
import { MainHeader } from './main-header';

export const Author = () => {
  const { data: session, update }: any = useSession();
  const { toast } = useToast();
  const { show, isOpen } = useDialog({ name: 'newUser' });

  useEffect(() => {
    const handleNewUserToast = async () => {
      if (session?.user?.isNewUser && !isOpen) {
        toast({
          title: `🎉 Woohoo 50 XP`,
          description: "You've gained XP for Signup!",
          icon: rewardLottie,
          duration: 5000,
        });
        show();
        await update({
          ...session,
          user: {
            ...session?.user,
            isNewUser: false, // Remove the key
          },
        });
      }
    };

    handleNewUserToast();
  }, [session]);
  return (
    <HomeLayout className='relative overflow-hidden'>
      {/* <Star /> */}
      <MainHeader
        color='#00FFD2'
        miniTitle='Author'
        subTitle="I'm Debug Media"
        description='Launched in 2019, Debug Media is a transformative force in the world of online education. Founded by an anonymous individual whose identity remains a mystery to this day, Debug Media is not a team or a corporation but the vision and relentless effort of one person.'
        className='mb-2'
        link={{
          href: '/blogs/who-is-debugmedia',
          title: 'Read more',
        }}
      />
      <DMImage
        src='/images/home/view-3d-male-teacher-removebg-preview.png'
        width={450}
        height={450}
        className='mx-auto'
        alt='Image of Debug Media'
      />
      {/* <div className="relative">
            <DMImage
               src="/images/home/view-3d-male-teacher-removebg-preview.png"
               width={450}
               height={450}
               className="mx-auto"
               alt="Image of Debug Media"
            />
            <video
               src="/images/home/top.mp4"
               autoPlay
               loop
               muted
               playsInline
               preload="auto"
               id="myVideo"
               className="absolute -top-2 right-7  md:right-44 lg:right-[300px] xl:right-[440px] w-12 h-12 object-cover -z-50 mix-blend-plus-lighter"
            ></video>
         </div> */}
      <div className='relative'>
        <Cobe />
        {/* <video
          autoPlay
          loop
          muted
          preload='auto'
          className='w-[80%] h-[80%] md:w-[50%] md:h-[50%]'
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            objectFit: 'contain',
            zIndex: -150,
            // mixBlendMode: 'plus-lighter',
            mixBlendMode: 'lighten',
          }}
        >
          <source src='/images/home/top.mp4' type='video/mp4' />
          Your browser does not support the video tag.
        </video> */}
      </div>
    </HomeLayout>
  );
};
